import type { FetchCustodiansApi } from 'epic/postTradeOperations/addon/fetchAddonCustodiansEpic';
import type { Custodian } from 'models/custodian';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export type CustodiansApi = FetchCustodiansApi;

function mapPayload(payload: any) {
  return payload.custodians.map(
    ({ code, id, label, eliotCode }: { code: string; id: string; label: string; eliotCode?: string }) => ({
      id: code ?? id,
      name: label,
      label,
      eliotCode,
    }),
  );
}

export function custodiansApi(http$: IHttpClient): CustodiansApi {
  return {
    fetchCustodians(clientId: string) {
      return http$
        .getJSON<Custodian[]>({
          url: `api/v1/custodians/${clientId}`,
        })
        .pipe(map(({ payload }) => mapPayload(payload)));
    },
  };
}
